import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Comapnies } from '../data';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalLoadingFileClientsComponent } from '../../modals/modal-loading-file-clients/modal-loading-file-clients.component';
import { ServiceInfoClientService } from '../../files-clients/service/service-info-client.service';

@Component({
  selector: 'app-my-companies-registred',
  templateUrl: './my-companies-registred.component.html',
  styleUrls: ['./my-companies-registred.component.scss']
})
export class MyCompaniesRegistredComponent {
  @Input() recieveCompanies: Comapnies[];
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  public dataSource!: MatTableDataSource<Comapnies>;
  public booCargando = true;

  displayedColumns: string[] = [
    'companyId',
    'companyName',
    'conectedSII'
  ];

  constructor(private router: Router, private authService: AuthService, private dialog: MatDialog, private serviceInfo: ServiceInfoClientService) {}

  ngOnInit() {
    this.openModalLoading();
    this.setDataSource(this.recieveCompanies || []); // Asegura que dataSource siempre tenga un valor inicial.
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['recieveCompanies'] && this.recieveCompanies && this.recieveCompanies.length > 0) {
      console.log('Datos recibidos en recieveCompanies:', this.recieveCompanies);
      this.setDataSource(this.recieveCompanies);
      this.dialog.closeAll();
      this.booCargando = false;
    } else if (changes['recieveCompanies'] && (!this.recieveCompanies || this.recieveCompanies.length === 0)) {
      console.log('No se recibieron datos en recieveCompanies o la lista está vacía.');
    }
  }

  private setDataSource(dataSource: Comapnies[]) {
    this.dataSource = new MatTableDataSource<Comapnies>(dataSource);
  }

  public redirectDashboardClient(companyId: number) {
    this.actualizarFacturas(companyId);
    this.authService.setItemSession("companieSelected", companyId.toString());
    this.router.navigate(['dashboards/cliente/dashboard/']);
  }

  public openModalLoading() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'transparent-dialog';
    dialogConfig.backdropClass = 'transparent-backdrop';
    this.dialog.open(ModalLoadingFileClientsComponent, dialogConfig);
  }

  public getRows(companies: any[]): any[][] {
    const rows = [];
    for (let i = 0; i < companies.length; i += 4) {
      rows.push(companies.slice(i, i + 4));
    }
    return rows;
  }

  public actualizarFacturas(companyId: number) {
    this.serviceInfo.updateInvocesCompany(1, companyId)
    .subscribe({
      next: (res) => {

      },
      error: (err) => {
        console.log(err)
      }
    })
  }
  
}
